import React from 'react';

interface UserAvatarProps {
  name?: string;
  email: string;
  size?: 'sm' | 'md' | 'lg';
  showGradient?: boolean;
  className?: string;
}

/**
 * UserAvatar - Reusable user avatar component
 * 
 * Displays user initials in a colored circle. Supports different sizes
 * and gradient backgrounds for visual variety.
 */
const UserAvatar: React.FC<UserAvatarProps> = ({
  name,
  email,
  size = 'md',
  showGradient = false,
  className = ''
}) => {
  const sizeClasses = {
    sm: 'w-6 h-6 text-xs',
    md: 'w-8 h-8 text-sm',
    lg: 'w-10 h-10 text-sm'
  };

  const bgClass = showGradient 
    ? 'bg-gradient-to-r from-blue-500 to-purple-600' 
    : 'bg-green-100';
    
  const textClass = showGradient 
    ? 'text-white' 
    : 'text-green-600';

  const initial = name 
    ? name.charAt(0).toUpperCase() 
    : email.charAt(0).toUpperCase();

  return (
    <div className={`${sizeClasses[size]} ${bgClass} rounded-full flex items-center justify-center ${className}`}>
      <span className={`font-medium ${textClass}`}>
        {initial}
      </span>
    </div>
  );
};

export default UserAvatar;
